import { QueryKey, MutationKey } from '@tanstack/react-query';

export const corpUsersQueryKeys: QueryKey = ['corp', 'users', 'query'];

export const createUserMutationKey: MutationKey = ['corp', 'user', 'create'];
export const updateUserMutationKey: MutationKey = ['corp', 'user', 'update'];
export const deleteUserMutationKey: MutationKey = ['corp', 'user', 'delete'];
export const restoreUserMutationKey: MutationKey = ['corp', 'user', 'restore'];
